import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core'
import {Router} from '@angular/router'
import {PostsService} from 'src/app/services/posts/posts.service'
import {UserService} from 'src/app/services/user/user.service'
import {TranslateConfigService} from 'src/app/services/translate-config.service'
import {CategoriesService} from 'src/app/services/api/categories.service'
import {NotificationService} from 'src/app/services/api/notification.service'
import {Subscription} from 'rxjs'
import {map, take} from 'rxjs/operators'
import Swiper from 'swiper'
import { UtilsService } from 'src/app/services/utils/utils.service'
import { AppStorageService } from 'src/app/services/app-storage.service'
import { StorageKeys } from 'src/app/services/storage-keys'
import { BrowserService } from 'src/app/services/browser.service'
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent.service'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { TranslateModule } from '@ngx-translate/core'
import { CategoryWebComponent } from '../category-web/category-web.component'
import { DialogComponent } from '../dialog/dialog.component'
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'

@Component({
  selector: 'app-home-web',
  templateUrl: './home-web.component.html',
  styleUrls: ['./home-web.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, CategoryWebComponent, DialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeWebComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('swiperRef', {static: false}) swiperRef!: ElementRef
  swiperInstance!: Swiper

  @Input() items: any[] = []
  @Input() selectedCategory: any
  @Input() itemsPerSlide: number = 6
  @Input() groupedResults: any[][] = []
  @Input() isLoading: boolean = false
  @Input() loadedAllCategories: boolean = false

  @Output() showAllCategories: EventEmitter<void> = new EventEmitter<void>()
  @Output() selectCategory: EventEmitter<any> = new EventEmitter<any>()
  @Output() loadMore: EventEmitter<any> = new EventEmitter<any>()
  @Output() refresh: EventEmitter<any> = new EventEmitter<any>()

  guest: boolean = false
  isGuest: boolean = false
  activeNext: boolean = true
  activePrevious: boolean = false
  authModal: boolean = false
  show: boolean = false

  isMobile = false

  // Propiedades para notificaciones
  hasUnreadNotifications: boolean = false
  private notificationCountSubscription: Subscription = new Subscription()

  // Propiedades para subcategorías
  subcategories: any[] = []
  isLoadingSubcategories: boolean = false
  loadedAllSubcategories: boolean = false
  currentPage: number = 1
  itemsPerPage: number = 20 // Aumentado para mostrar más elementos
  viewingSubcategories: boolean = false

  // Propiedades para la opción "Ver todo"
  viewAllCategory = {
    id: 0,
    name: '',
    imagen: '',
    image: 'assets/icons/icon-256.webp',
    isViewAll: true
  }

  viewAllSubcategory = {
    id: 0,
    name: '',
    imagen: '',
    image: 'assets/icons/icon-256.webp',
    isViewAll: true
  }

  constructor(
    private router: Router,
    private userService: UserService,
    private postsService: PostsService,
    public translateConfigService: TranslateConfigService,
    private categoriesService: CategoriesService,
    private notificationService: NotificationService,
    private utilsService: UtilsService,
    private storage: AppStorageService,
    private browserService: BrowserService,
    private cookieConsentService: CookieConsentService
  ) {
    // Inicializar traducciones
    this.updateTranslations();
  }

  private updateTranslations() {
    this.viewAllCategory.name = this.translateConfigService.getItemTranslated('HOME.VIEW_ALL');
    this.viewAllSubcategory.name = this.translateConfigService.getItemTranslated('HOME.VIEW_ALL');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize()

    // Reinicializar swiper si existe
    if (this.swiperInstance) {
      setTimeout(() => {
        this.swiperInstance.update();
      }, 100);
    }
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 600
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && !changes['items'].firstChange) {


      // Reinicializar swiper cuando cambien los items
      setTimeout(() => {
        this.reinitializeSwiper();
      }, 100);
    }

    if (changes['selectedCategory']) {
      // Si el componente padre envía null o undefined, respetarlo
      if (changes['selectedCategory'].currentValue === null || changes['selectedCategory'].currentValue === undefined) {
        this.selectedCategory = null;
        this.viewingSubcategories = false;

      } else {
        this.selectedCategory = changes['selectedCategory'].currentValue;

      }
    }
  }

  async ngOnInit() {


    this.checkScreenSize()
    this.guest = await this.userService.checkGuest()
    this.subscribeToNotificationCount()

    // Sincronizar con localStorage ANTES de inicializar el swiper
    await this.syncWithLocalStorage()

    // Configurar el swiper después de que el DOM esté listo
    setTimeout(() => {
      this.initializeSwiper();
    }, 300);

    // Actualizar textos cuando cambie el idioma
    this.translateConfigService.onLanguageChange().subscribe(() => {
      this.updateTranslations();
    });
  }

  private initializeSwiper() {
    if (this.swiperRef && this.swiperRef.nativeElement) {
      const swiperEl = this.swiperRef.nativeElement;

      // Configuración del swiper
      const swiperConfig = {
        navigation: {
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
          disabledClass: 'disabled'
        },
        on: {
          slideChange: (swiper: any) => {

            this.updateNavigationButtons();
          },
          init: (swiper: any) => {

            this.updateNavigationButtons();
          },
          resize: (swiper: any) => {
            setTimeout(() => {
              this.updateNavigationButtons();
            }, 100);
          },
          reachBeginning: () => {

            this.activePrevious = false;
          },
          reachEnd: () => {

            this.activeNext = false;
          }
        }
      };

      // Aplicar configuración
      Object.assign(swiperEl, swiperConfig);
      swiperEl.initialize();

      this.swiperInstance = swiperEl.swiper;


      // Conectar botones de navegación manualmente
      setTimeout(() => {
        this.connectNavigationButtons();
      }, 200);
    }
  }

  private reinitializeSwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    setTimeout(() => {
      this.initializeSwiper();
    }, 100);
  }

  private connectNavigationButtons() {
    const nextButton = document.querySelector('.custom-next') as HTMLElement;
    const prevButton = document.querySelector('.custom-prev') as HTMLElement;

    if (nextButton && prevButton && this.swiperInstance) {


      // Limpiar event listeners existentes
      nextButton.onclick = null;
      prevButton.onclick = null;

      // Conectar botón siguiente
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.swiperInstance && this.activeNext) {
          this.swiperInstance.slideNext();
        }
      });

      // Conectar botón anterior
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.swiperInstance && this.activePrevious) {
          this.swiperInstance.slidePrev();
        }
      });

      // Actualizar estado inicial
      this.updateNavigationButtons();


    } else {

    }
  }

  private updateNavigationButtons() {
    if (this.swiperInstance) {
      const wasAtBeginning = !this.activePrevious;
      const wasAtEnd = !this.activeNext;

      this.activePrevious = !this.swiperInstance.isBeginning;
      this.activeNext = !this.swiperInstance.isEnd;

      // Forzar detección de cambios
      setTimeout(() => {
        const prevButton = document.querySelector('.custom-prev') as HTMLElement;
        const nextButton = document.querySelector('.custom-next') as HTMLElement;

        if (prevButton) {
          if (this.activePrevious) {
            prevButton.classList.remove('disabled');
          } else {
            prevButton.classList.add('disabled');
          }
        }

        if (nextButton) {
          if (this.activeNext) {
            nextButton.classList.remove('disabled');
          } else {
            nextButton.classList.add('disabled');
          }
        }
      }, 10);
    }
  }

  /**
   * Se suscribe al contador de notificaciones reactivo
   */
  private subscribeToNotificationCount() {


    this.notificationCountSubscription = this.notificationService.notificationCount$
      .pipe(
        map(count => count > 0)
      )
      .subscribe({
        next: (hasNotifications) => {
          this.hasUnreadNotifications = hasNotifications;

        },
        error: (error) => {
          this.hasUnreadNotifications = false;
        }
      });
  }

  /**
   * Sincronizar estado con localStorage al inicializar o después de F5
   */
  private async syncWithLocalStorage() {
    try {
      const isSubcategoryStr = this.storage.get(StorageKeys.IS_SUBCATEGORY);
      const storedCategory = this.storage.get(StorageKeys.SELECTED_CATEGORY);

      if (isSubcategoryStr && storedCategory) {
        const isSubcategory = JSON.parse(isSubcategoryStr);
        let categoryData = JSON.parse(storedCategory);
        // Ensure translationKey exists for 'view all' saved items
        if (categoryData && !categoryData.translationKey && categoryData.id === 0) {
          categoryData.translationKey = 'HOME.VIEW_ALL';
        }

        if (isSubcategory && categoryData && categoryData.id && categoryData.id !== 0) {


          this.selectedCategory = categoryData;
          this.viewingSubcategories = true;

          // Cargar subcategorías desde la API
          await this.loadSubcategoriesInternal(categoryData);

          // Notificar al componente padre sobre la categoría seleccionada
          this.selectCategory.emit(categoryData);
        } else {
          // Resetear estado si no hay datos válidos
          this.resetToInitialState();
        }
      } else {
        // No hay estado guardado, mantener estado inicial

        this.resetToInitialState();
      }
    } catch (error) {
      this.resetToInitialState();
    }
  }

  private resetToInitialState() {
    this.viewingSubcategories = false;
    this.selectedCategory = null;
    this.subcategories = [];
    this.loadedAllSubcategories = false;
    this.currentPage = 1;
    this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, false);
  }

  showAll() {


    // Resetear estado local
    this.resetToInitialState();

    // Limpiar localStorage
    this.storage.remove(StorageKeys.SELECTED_CATEGORY);
    this.storage.remove(StorageKeys.SELECTED_SUBCATEGORY);

    // Emitir evento al componente padre
    this.showAllCategories.emit();

    // Reinicializar swiper después de cambio de estado
    setTimeout(() => {
      this.reinitializeSwiper();
    }, 100);
  }

  select(category: any) {
    if (category.isViewAll) {
      if (this.viewingSubcategories) {
        this.navigateToViewAllInCategory();
      } else {
        this.navigateToViewAll();
      }
      return;
    }

    if (this.viewingSubcategories) {
      this.storage.setJSON(StorageKeys.SELECTED_SUBCATEGORY, category);
      this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, true);

      this.navigateToListing(category);
    } else {
  const toStore = Object.assign({}, category);
  if (!toStore.translationKey && toStore.id === 0) toStore.translationKey = 'HOME.VIEW_ALL';
  this.storage.setJSON(StorageKeys.SELECTED_CATEGORY, toStore);
      this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, false);
      this.storage.remove(StorageKeys.SELECTED_SUBCATEGORY);

      this.loadSubcategories(category);
    }
  }

  // Método para cargar subcategorías de una categoría seleccionada
  loadSubcategories(category: any) {
    this.selectedCategory = category;
    this.selectCategory.emit(category);
    this.viewingSubcategories = true;
    this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, true);

  const toStore = Object.assign({}, this.selectedCategory);
  if (!toStore.translationKey && toStore.id === 0) toStore.translationKey = 'HOME.VIEW_ALL';
  this.storage.setJSON(StorageKeys.SELECTED_CATEGORY, toStore);

  this.loadSubcategoriesInternal(category);
  }

  /**
   * Cargar subcategorías internamente usando el servicio
   */
  private async loadSubcategoriesInternal(category: any): Promise<void> {
    if (!category || !category.id || category.id === 0) {

      return;
    }

    this.isLoadingSubcategories = true;
    this.currentPage = 1;
    this.subcategories = [];
    this.loadedAllSubcategories = false;

    try {


      const response = await this.categoriesService.getSubcategoriesByCategoryId(
        category.id,
        1,
        this.itemsPerPage,
        'name',
        1
      ).pipe(take(1)).toPromise();

      if (response) {
        this.subcategories = response.subcategories || [];
        this.loadedAllSubcategories = !response.pagination.hasMorePages;

        // Reinicializar swiper después de cargar subcategorías
        setTimeout(() => {
          this.reinitializeSwiper();
        }, 100);
      }
    } catch (error) {
      this.subcategories = [];
    } finally {
      this.isLoadingSubcategories = false;
    }
  }

  // Método para navegar a la vista de listado sin filtrar por categoría
  navigateToViewAll() {
    this.storage.setJSON(StorageKeys.SELECTED_CATEGORY, {
      id: 0,
      name: this.translateConfigService.getItemTranslated('HOME.VIEW_ALL'),
      translationKey: 'HOME.VIEW_ALL'
    });
    this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, false);
    this.storage.remove(StorageKeys.SELECTED_SUBCATEGORY);


    this.router.navigate(['/app/listing']);
  }

  // Método para navegar a la vista de listado con todas las subcategorías de la categoría seleccionada
  navigateToViewAllInCategory() {
    const currentCategory = this.storage.get(StorageKeys.SELECTED_CATEGORY);
    const categoryObj = currentCategory ? JSON.parse(currentCategory) : this.selectedCategory;

    if (!currentCategory) {
      this.storage.setJSON(StorageKeys.SELECTED_CATEGORY, this.selectedCategory);
    }

    this.storage.setJSON(StorageKeys.SELECTED_SUBCATEGORY, {
      id: 0,
  name: this.translateConfigService.getItemTranslated('HOME.VIEW_ALL'),
  translationKey: 'HOME.VIEW_ALL',
      categoryId: categoryObj.id
    });

    this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, true);


    this.router.navigate(['/app/listing']);
  }

  // Método para navegar a la vista de listado con la subcategoría seleccionada
  navigateToListing(subcategory: any) {
    this.storage.setJSON(StorageKeys.SELECTED_SUBCATEGORY, subcategory);

    const currentCategory = this.storage.get(StorageKeys.SELECTED_CATEGORY);
    if (!currentCategory) {
  const toStore = Object.assign({}, this.selectedCategory);
  if (!toStore.translationKey && toStore.id === 0) toStore.translationKey = 'HOME.VIEW_ALL';
  this.storage.setJSON(StorageKeys.SELECTED_CATEGORY, toStore);

    }

    this.storage.setJSON(StorageKeys.IS_SUBCATEGORY, true);


    this.router.navigate(['/app/listing']);
  }

  navigate(path: string) {
    this.router.navigate([path])
  }

  openCookieSettings() {
    this.cookieConsentService.requestOpenConfig()
  }

  async openCookiePolicy() {
    await this.browserService.openCookiePolicy()
  }

  async openPrivacyPolicy() {
    await this.browserService.openPrivacyPolicy()
  }

  userModal() {
    this.isGuest = !this.isGuest
  }

  async newPost() {
    // Rechequear el estado de invitado en el momento del click: this.guest se
    // captura en ngOnInit y puede quedar obsoleto si el usuario inicia sesión
    // después (en web esto provocaba que pidiera login estando ya logueado).
    const isGuest = await this.userService.checkGuest()
    this.guest = isGuest
    if (isGuest) {
      this.userModal()
    } else {
      this.navigate('/create-post')
    }
  }

  confirm() {
    this.isGuest = false
    setTimeout(() => {
      this.router.navigate(['/login'])
    }, 200)
  }

  openModal() {
    this.show = !this.show
  }

  async setPostToCreate(type: number) {
    // Guardar el tipo de publicación para preservar la intención
    this.postsService.setPostToCreate(type);

    // Rechequear el estado de invitado justo en el click
    const isGuest = await this.userService.checkGuest();

    if (!isGuest) {
      this.navigate('/create-post');
    } else {
      // Guardar redirección tras login
      this.storage.set(StorageKeys.REDIRECT_URL, '/create-post');
      this.openModal();
    }
  }

  confirmLogin() {
    this.show = false
    setTimeout(async () => {
      
      const isWeb = await this.utilsService.detectIsWeb()

      this.router.navigate([!isWeb?'/selection': '/login'])
    }, 200)
  }

  /**
   * Navegar al slide anterior
   */
  goToPrevSlide(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.swiperInstance && this.activePrevious) {
      this.swiperInstance.slidePrev();
    } else {

    }
  }

  /**
   * Navegar al slide siguiente
   */
  goToNextSlide(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.swiperInstance && this.activeNext) {
      this.swiperInstance.slideNext();
    } else {

    }
  }

  ngOnDestroy() {


    // Limpiar suscripciones
    if (this.notificationCountSubscription) {
      this.notificationCountSubscription.unsubscribe();
    }

    // Destruir swiper si existe
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }
}
